import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Clock, Loader2 } from "lucide-react";
import { adminApi, formatApiError } from "@/context/AuthContext";

// Admin > Lieux: fills every place's opening hours (Google first, then OpenStreetMap), with live progress
export const HoursSync = () => {
  const qc = useQueryClient();
  const [st, setSt] = useState(null);

  useEffect(() => {
    if (!st?.running) return undefined;
    const t = setInterval(async () => {
      try {
        const { data } = await adminApi.get("/admin/places/hours-sync");
        setSt(data);
        if (!data.running) {
          qc.invalidateQueries({ queryKey: ["/places"] });
          toast.success(`Horaires trouvés : ${data.google} via Google, ${data.osm} via OpenStreetMap, ${data.none} sans horaires.`);
        }
      } catch { /* keep polling */ }
    }, 3000);
    return () => clearInterval(t);
  }, [st?.running, qc]);

  useEffect(() => {
    adminApi.get("/admin/places/hours-sync").then(({ data }) => { if (data?.running) setSt(data); }).catch(() => {});
  }, []);

  const start = async () => {
    try {
      setSt((await adminApi.post("/admin/places/hours-sync")).data);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };

  const pct = st?.total ? Math.round((st.done / st.total) * 100) : 0;
  return (
    <div className="flex flex-wrap items-center gap-4 mb-6" data-testid="hours-sync">
      <button type="button" onClick={start} disabled={st?.running} data-testid="hours-sync-btn"
        className="inline-flex items-center gap-2 border border-white/30 text-white uppercase text-xs font-bold tracking-[0.15em] px-4 py-2.5 hover:border-white transition-colors disabled:opacity-50">
        {st?.running ? <Loader2 className="w-4 h-4 animate-spin" /> : <Clock className="w-4 h-4" />} Remplir les horaires (Google + OpenStreetMap)
      </button>
      {st?.running && (
        <p className="text-sm text-zinc-300" data-testid="hours-sync-progress">
          {st.done} / {st.total} lieux ({pct} %) · Google {st.google} · OSM {st.osm}{st.google_enabled ? "" : " · Google non configuré"}
        </p>
      )}
      {st?.error && <p className="text-sm text-yellow-400" data-testid="hours-sync-error">{st.error}</p>}
    </div>
  );
};
